import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentContainer, MetaInformationContainer } from './MetaInformation.styles';
import { isLivestream } from '../../../../../play-core/models/Media';
import { DotSeparator } from '../../../components/DotSeparator/DotSeparator';
import { InfoIcon, getInfoIcons } from '../../../components/InfoIcon/InfoIcon';
import { InfoLabel } from '../../../components/InfoLabel/InfoLabel';
import { getExpiringSoonLabelProps, getLivestreamLabelProps } from '../../../components/InfoLabel/label-helper';
import { useHydrated } from '../../../hooks/use-hydrated';
import { useMediaTeaserConfig } from '../../../providers/UiConfigProvider/UiConfigContext';
import { shortDateFormat } from '../../../utils/date-formatter';
import { formatDuration } from '../../../utils/duration-formatter';
import { dateOrWebFirstText, formatSeason } from '../../../utils/media-helper';
import { createSeparatedList } from '../../../utils/separated-list-helper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const getMetaInfos = (videoDetail, isExpiringSoon, showSeasonAndEpisode, t) => {
  const {
    publishDate,
    validTo
  } = videoDetail;
  const showMetaInformation = !isLivestream(videoDetail);
  const duration = videoDetail.duration ?? 0;
  const hasValidDuration = duration > 0;
  const showValidTo = validTo && showMetaInformation && !isExpiringSoon;
  const metaInfos = [];
  if (showMetaInformation) {
    if (showSeasonAndEpisode && (videoDetail.seasonNumber || videoDetail.episodeNumber)) {
      metaInfos.push(formatSeason(videoDetail.seasonNumber, videoDetail.episodeNumber));
    } else if (publishDate) {
      metaInfos.push(dateOrWebFirstText(publishDate, t));
    }
    if (hasValidDuration) {
      metaInfos.push(formatDuration(duration, t));
    }
  }
  if (showValidTo) {
    metaInfos.push(`${t('videoDetailPage.validTo')} ${shortDateFormat(validTo)}`);
  }
  return metaInfos;
};
export const MetaInformation = ({
  videoDetail
}) => {
  const {
    t
  } = useTranslation();
  const isHydrated = useHydrated();
  const livestreamLabelProps = getLivestreamLabelProps(t, videoDetail);
  const expiringSoonLabelProps = getExpiringSoonLabelProps(videoDetail, 48, t);
  const labelProps = livestreamLabelProps || expiringSoonLabelProps;
  const {
    displaySeasonAndEpisodes
  } = useMediaTeaserConfig();
  const topicList = videoDetail?.topics?.map(topic => topic.id) || [];
  const showSeasonAndEpisode = !!displaySeasonAndEpisodes?.topics.some(topic => topicList.includes(topic));
  const infoIcons = getInfoIcons(videoDetail, t);
  const metaInfos = getMetaInfos(videoDetail, !!expiringSoonLabelProps, showSeasonAndEpisode, t);
  const list = metaInfos.map(metaInfo => /*#__PURE__*/_jsx("span", {
    children: metaInfo
  }, metaInfo));
  const dotSeparatedList = createSeparatedList(list, /*#__PURE__*/_jsx(DotSeparator, {
    spaceAround: 0
  }));
  return /*#__PURE__*/_jsxs(MetaInformationContainer, {
    children: [infoIcons.length > 0 && /*#__PURE__*/_jsx(ContentContainer, {
      children: infoIcons.map((infoIcon, index) => /*#__PURE__*/_jsx(InfoIcon, {
        icon: infoIcon.icon,
        text: infoIcon.text
      }, index))
    }), /*#__PURE__*/_jsxs(ContentContainer, {
      children: [labelProps && /*#__PURE__*/_jsx(InfoLabel, {
        ...labelProps
      }), isHydrated && dotSeparatedList]
    })]
  });
};